export default "__VITE_ASSET__zJapIYqI__"